<template>
    <ul class="sidebar navbar-nav">
  
        <li class="nav-item" :class="{ active: index == 1}" v-if="director_system">
          <router-link class="nav-link" to="/director_Group">
            <i class="fas fa-users"></i>
            <span>Group</span>
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: index == 2}" v-if="director_system">
          <router-link class="nav-link" to="/director_Permission">
            <i class="fas fa-user-shield"></i>
            <span>Permission</span>
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: index == 3}" v-if="director_system">
          <router-link class="nav-link" to="/director_kind">
            <i class="fas fa-tasks"></i>
            <span>Specialization</span>
          </router-link>
        </li>
        <li class="nav-item" :class="{ active: index == 4}" v-if="director_system">
          <router-link class="nav-link" to="/director_ratevalue">
            <i class="fas fa-database"></i>
            <span>Grade Rate</span>
          </router-link>
        </li>
      </ul>
  </template>
  
  <script>
  export default {
    name: "NhanSuSideBar",
    props: ['index'],
    computed:{
      director_system() {
      return this.$store.getters.hasPermission("director_system");
    },

    }
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  </style>
  